import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IUpdatePassageRequest } from "./types";

/**
 * shared passage를 수정하는 API 함수
 */
export const apiUpdatePassage = async (
  id: string,
  data: IUpdatePassageRequest
) => {
  const response = await apiPatch(`/passages/${id}`, data);
  return response.data;
};

/**
 * shared passage를 수정하는 React Query 훅
 */
export const useUpdatePassage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: IUpdatePassageRequest }) =>
      apiUpdatePassage(id, data),
    onSuccess: (_, variables) => {
      // 특정 passage와 관련된 캐시 갱신
      queryClient.invalidateQueries({ queryKey: ["passage", variables.id] });
      queryClient.invalidateQueries({ queryKey: ["passages"] });
    },
  });
};

export default useUpdatePassage;
